import { Form } from '@unform/web';
import React, { useEffect, useState } from 'react';
import { FaBell, FaCertificate, FaCheckCircle, FaExclamationCircle, FaFile, FaIdBadge, FaImages, FaQuestionCircle, FaReceipt, FaRegIdBadge, FaSubscript, FaTicketAlt, FaTrophy, FaUser } from 'react-icons/fa';
import { FiMessageCircle } from 'react-icons/fi';

import { IconType } from 'react-icons/lib';
import { useAuth } from '../../../../hooks/Auth';
import { useConfiguration } from '../../../../hooks/Configuration';
import api from '../../../../services/api';
import InOut from '../../../DashboardPages/core/components/Forms/InOut';


import PagamentosGeral from '../PagamentosGeral';


import { Container, ContainerWhite } from './styles';
import { useParams } from 'react-router-dom';
import { useModal } from '../../../../hooks/Modal';
import { useToast } from '../../../../hooks/Toast';
import Input from '../../../../components/Forms/Input';
import Loader from '../../../../components/Loader';
import SelectSimple from '../../../../components/Forms/SelectSimple';
import CheckboxInput from '../../../../components/Forms/CheckboxInput';
import { useLanguage } from '../../../../hooks/Language';
import CodeUsage from '../InscricoesComMeuCodigo';
import MeusIngressos from '../MeusIngressos';
import MinhasIndicacoes from '../MinhasIndicacoes';
import CourseProductsSubscriptionModule from 'src/pages/CourseProductSubscription';




const UserHome: React.FC = () => {

  const { user } = useAuth();
  const { projectHash } = useParams<Record<string, any>>();
  const [userInfo, setUserInfo] = useState<Record<string, any>>({});
  const [projects, setProjects] = useState<Array<Record<string, any>>>([]);
  const [dashboardStatus, setDashboardStatus] = useState('myActivities');
  const { addModal } = useModal();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);


  const changeStatus = (value) => {
    setDashboardStatus(value);
    window.scrollTo(0, 0);
  }

  const { configuration } = useConfiguration();
  const [myMedicSubscription, setMyMedicSubscription] = useState<Record<string, any>>({})
  const { translate } = useLanguage();
  const loadProjects = async () => {
    const response = await api.get('/get-projects');
    if (response?.data) {

      response?.data?.rows.sort((a, b) => {
        return a.title > b.title ? 1 : a.title < b.title ? -1 : 0;
      })


      setProjects(response?.data.rows);
    }
  }



  useEffect(() => {
    loadProjects();

  }, [])



  const dashboardStates = [

    { title: translate('Selecionar atividades'), Icon: <FaBell />, state: 'myActivities', getPage: () => <CourseProductsSubscriptionModule />, show: false },

    { title: translate('Minhas compras'), Icon: <FaBell />, state: 'myPayments', getPage: () => <PagamentosGeral changeStatus={(value) => changeStatus(value)} />, show: false },
    { title: translate('Meus ingressos'), Icon: <FaReceipt />, state: 'myCodeUsage', getPage: () => <MeusIngressos changeStatus={(value) => changeStatus(value)} />, show: false },
    { title: translate('Meus chamados'), Icon: <FaReceipt />, state: 'myTicketCall', getPage: () => <MeusIngressos changeStatus={(value) => changeStatus(value)} />, show: false },
    { title: translate('Minhas indicações'), Icon: <FaReceipt />, state: 'recommendation', getPage: () => <MinhasIndicacoes changeStatus={(value) => changeStatus(value)} />, show: false },

  ]







  const currentState = dashboardStates.find(state => state.state === dashboardStatus);





  return (
    <>
      {loading && <Loader message='Carregando ...' />}
      <Container id="dashboardUser" >
        <div className='p800 headerBoard' >
          <h2>{configuration?.title}</h2>
          <div style={{ display: 'flex', width: '100%', gap: '10px', justifyContent: 'flex-end' }}>
            {user?.seller_hash ? <button className={`greenButton2 ${dashboardStatus === 'recommendation' ? 'buttonColored' : ''}`} onClick={() => setDashboardStatus('recommendation')}>{translate('Minhas indicações')}</button>
              : <></>}
            <button className={`greenButton2 ${dashboardStatus === 'myActivities' ? 'orangeButton' : 'orangeButton'}`} onClick={() => setDashboardStatus('myActivities')}>{translate('Selecionar atividades')}</button>

            <button className={`greenButton2 ${dashboardStatus === 'myPayments' ? 'buttonColored' : 'buttonColored'}`} onClick={() => setDashboardStatus('myPayments')}>{translate('Minhas compras')}</button>
            <button className={`greenButton2 ${dashboardStatus === 'myCodeUsage' ? 'buttonColored' : 'buttonColored'}`} onClick={() => setDashboardStatus('myCodeUsage')}>{translate('Meus ingressos')}</button>
          </div>

          {dashboardStatus === 'myPayments' ? <>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginTop: '10px' }} >


            </div>
            {currentState?.getPage()} </> : <>


            <div >
              <h2 style={{ background: '#41517E', padding: '10px', margin: '10px 0px', marginBottom: '20px', color: '#fff', borderRadius: '5px' }}>
                {configuration?.current_event_id_response?.title}
              </h2>


            </div>


            <div className='user-block shadow'>
              <div className='content-block'>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
                  {dashboardStates.map(dash => {
                    return dash?.show === false ? <> </> : <nav key={dash.title} onClick={() => changeStatus(dash.state)} className={`dashboardMenu ${dashboardStatus === dash.state ? 'dashboardMenuActive' : ''}`} > {dash.Icon} <p className='computerOnly'>{dash.title}</p></nav>
                  })}



                </div>
              </div>


            </div>

            <div className='user-header-submenu'>
              <h2>
                {currentState?.Icon}{` ${currentState?.title}`}
              </h2>

              <div />

            </div>

            {currentState?.getPage()}



          </>}


        </div>
      </Container>
    </>
  );
};
export default UserHome;
